import { gql } from '@apollo/client';

/**
 * CREATE_RECEIPT_PDF_MUTATION
 * 
 * Creates a PDF receipt for a transaction
 * 
 * @param id - The transaction ID (base64 encoded string)
 * 
 * @returns PDF data containing URL and expiration date
 */
export const CREATE_RECEIPT_PDF_MUTATION = gql`
	mutation CreateReceiptPdf($id: String!) {
		createReceiptPdf(input: { id: $id }) {
			pdfData {
				url
				expirationDate
			}
		}
	}
`;
